var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-star-rating",attrs:{"height":_vm.getSize,"width":_vm.getSize,"viewBox":_vm.viewBox},on:{"mousemove":_vm.mouseMoving,"click":_vm.selected}},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"","width":_vm.size}})])
}
var staticRenderFns = []

export { render, staticRenderFns }